import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => {
    try { return localStorage.getItem("fichaje_last_email") || ""; } catch { return ""; }
  });
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      try { localStorage.setItem("fichaje_last_email", email); } catch (err) { console.debug("localStorage unavailable", err); }
      toast.success("Sesión iniciada");
      navigate("/admin/dashboard");
    } else {
      toast.error(r.error || "Error de inicio de sesión");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg)" }}>
      <div className="card-flat w-full max-w-md p-10">
        <Link
          to="/"
          data-testid="back-to-fichaje"
          className="inline-flex items-center gap-2 text-sm text-[var(--text-secondary)] mb-8 hover:text-[var(--text-primary)]"
        >
          <ArrowLeft size={16} /> Volver
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center"
            style={{ background: "var(--primary)" }}
          >
            <ShieldCheck size={24} color="#FFF" weight="duotone" />
          </div>
          <div>
            <div className="label-cap">administración</div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Iniciar sesión</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-cap block mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full px-4 py-3 rounded-xl border border-[var(--border)] bg-white focus:outline-none focus:border-[var(--primary)]"
              placeholder="admin@fichaje.es"
            />
          </div>
          <div>
            <label className="label-cap block mb-2">Contraseña</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full px-4 py-3 rounded-xl border border-[var(--border)] bg-white focus:outline-none focus:border-[var(--primary)]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3 rounded-xl btn-primary font-display font-bold mt-2 disabled:opacity-50"
          >
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
